import { render, staticRenderFns } from "./LitigationLogin.vue?vue&type=template&id=4d8a30f1&scoped=true&"
import script from "./LitigationLogin.vue?vue&type=script&lang=js&"
export * from "./LitigationLogin.vue?vue&type=script&lang=js&"
import style0 from "./LitigationLogin.vue?vue&type=style&index=0&id=4d8a30f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a30f1",
  null
  
)

export default component.exports